import { Component } from '@angular/core';

@Component({
  selector: 'cx-register-page',
  templateUrl: './register-page.component.html',
  styleUrls: ['./register-page.component.scss']
})
export class RegisterPageComponent {
  constructor() {}
}
